import { setPostRequestParams } from 'utilities/http';

function getGiftCardBalance (data, successCallback, errorCallback) {

	return fetch(
		'/api/globalcart/current-cart/gift-card/balance/',
		setPostRequestParams({
			data,
			credentials: 'same-origin',
			headers: { 'Content-Type': 'application/json;charset=UTF-8' }
		})
	)
		.then((response) => {

			if (response.status === 200) {

				return response.json();

			}
			if (typeof errorCallback === 'function') {

				errorCallback(response);

			}

			return response;

		})
		.then((response) => {

			if (response) {

				if (response.IsSuccess) {

					if (typeof successCallback === 'function') {

						successCallback(response);

					}

				} else {

					errorCallback(response);

				}

			} else {

				if (typeof errorCallback === 'function') {

					errorCallback();

				}

			}

		})
		.catch(() => {

			if (typeof errorCallback === 'function') {

				errorCallback();

			}

		});

}

export default getGiftCardBalance;
